import Color from './color';

export default class PCCSBright extends Color {
    static diverse() {
        return [
            '#d75674',
            '#f15d69',
            '#f16056',
            '#f7774d',
            '#fb8d3d',
            '#fba52f',
            '#f9bb2b',
            '#f2d324',
            '#d9c81b',
            '#b7bf19',
            '#76bb4c',
            '#00b275',
            '#00a583',
            '#00a39b',
            '#0094a1',
            '#008fb3',
            '#007daf',
            '#1979ba',
            '#4d73bb',
            '#716bb6',
            '#8b63ac',
            '#9c5da0',
            '#ab5792',
            '#cc5c87',
        ];
    }
}
